import React, { useCallback, useMemo, useState } from 'react';
import { TableProps } from './table-props';
import { TableState } from './table-state';
import { TableStateContext } from './table-state-context';
import { cx } from '@mint/core';
import styled from 'styled-components';

/**
 * List root class name.
 */
const ROOT_CLASS_NAME = 'table';

/**
 * Component to use.
 */
const DEFAULT_COMPONENT = 'div';

/**
 * List component implementation before styling.
 */
export const TableComponent = React.forwardRef<any, TableProps>(
  (props, ref): React.ReactElement => {
    const {
      children,
      className,
      component: Component = DEFAULT_COMPONENT,
      columnWidths: initialColumnWidths,
      ...rest
    } = props;

    const [columnWidths, setColumnWidths] = useState(initialColumnWidths || {});

    const setColumnWidth = useCallback(
      (columnName: string, width: number): void => {
        setColumnWidths({ ...columnWidths, [columnName]: width });
      },
      [columnWidths],
    );

    const componentProps = {
      className: cx(ROOT_CLASS_NAME, className),
      ...rest,
      ref,
    };

    const tableState = useMemo(
      (): TableState => ({
        columnWidths,
        setColumnWidth,
      }),
      [columnWidths, setColumnWidth],
    );

    return (
      <TableStateContext.Provider value={tableState}>
        <Component {...componentProps}>{children}</Component>
      </TableStateContext.Provider>
    );
  },
);

TableComponent.displayName = 'Table';

export const Table = styled(TableComponent)``;
